// extracted by mini-css-extract-plugin
module.exports = {"newButton":"styles_newButton__3ncrw"};